<template>
  <div>
    <div v-if="$i18n.locale === 'pe'">
      <div v-if="$store.state.currentUser.user.rol !== 'CLIENT'" id="notPermissions">
        <p>Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información.</p>
      </div>
    </div>
    <div v-if="$i18n.locale === 'br'">
      <div v-if="$store.state.currentUser.user.rol !== 'CLIENT'" id="notPermissions">
        <p>Você não tem permissão para visualizar este menu. Consulte a equipe de desenvolvimento para mais informações.</p>
      </div>
    </div>
    <div v-if="$i18n.locale === 'cl'">
      <div v-if="$store.state.currentUser.user.rol !== 'CLIENT'" id="notPermissions">
        <p>Usted no tiene permisos para ver este menú. Consulte al equipo de desarrollo para más información.</p>
      </div>
      <div v-if="$i18n.locale === 'cl' && $store.state.currentUser.user.rol === 'CLIENT' " class="pay-here-content">
        <div class="steps-module-content">
          <StepsBar :steps="steps" />
        </div>
        <div class="step-view">
          <router-view
            @enableNextButton="enableNextButton=$event"
            @enableBackButton="enableBackButton=$event"
            @sendNameNextStep="setNextStepName"
            @sendNameBackStep="setBackStepName"
            @set-event-next="setEventNext"
            @setTransactionId="setTransactionId"
            @updateFooterButtons="updateFooterButtons"
            @open-confirm-transaction-modal="openConfirmTransactionModal"
            @open-cancel-transaction-modal="openCancelTransactionModal"
            @confirm-deselect-payment="confirmDeselectPayment"
            @open-trusted-ids-modal="isTrustedIdNumbersCardModalActive=true" />
        </div>
        <div class="footer-resume transition-slow" :class="{ active: showFooter && transaction._id }">
          <div
            class="button-content transition-slow"
            :class="{ 'hidden': !backStepName, 'complete': !showNextButton }">
            <button
              v-if="backStepName !== ''"
              v-show="showBackButton"
              id="backButton"
              class="button is-button-secondary is-rounded"
              :disabled="!enableBackButton"
              @click="returnBack">
              Atrás
            </button>
          </div>
          <div id="total-amount-container" class="total-content">
            <p>
              Total a pagar: <span>$ {{ transactionAmount }} </span>
              <b-tooltip
                v-if="usedClientBalance"
                id="total-details-tooltip"
                multilined
                :triggers="['click', 'hover']"
                position="is-left">
                <i id="total-details" class="fas fa-info-circle" />
                <template #content>
                  <div class="is-flex is-justify-content-space-between">
                    <span class="has-text-white">Cuotas: </span>
                    <span class="has-text-white">$ {{ transactionDebtAmount }}</span>
                  </div>
                  <div class="is-flex is-justify-content-space-between">
                    <span class="has-text-white">Saldo utilizado: </span>
                    <span class="has-text-white">$ {{ usedClientBalance }}</span>
                  </div>
                  <div class="is-flex is-justify-content-space-between has-text-weight-bold">
                    <span class="has-text-white">Total a pagar: </span>
                    <span class="has-text-white">$ {{ transactionAmount }}</span>
                  </div>
                </template>
              </b-tooltip>
            </p>
          </div>
          <div v-show="showNextButton" class="button-content transition-slow" :class="backStepName !== '' ? '' : 'complete'">
            <button
              id="continueButton"
              class="button is-button-primary is-rounded"
              :disabled="!enableNextButton"
              @click="continueNext">
              {{ nextButtonText }}
            </button>
          </div>
        </div>
        <b-modal v-model="confirmingTransaction.isModalActive" :width="400">
          <div class="modal-card-body has-text-centered">
            <div>
              <a class="close-modal" @click="confirmingTransaction.isModalActive=false">
                <img src="@/ui/assets/img/plus-button.svg">
              </a>
            </div>
            <h3 class="modal-title">¡Último paso!</h3>
            <p class="modal-content">
              Presiona el botón e iniciaremos la validación de tu pago (te notificaremos a tu mail si todo esta ok)
            </p>
            <p class="modal-footer">El proceso de validación puede tomar hasta 24 hrs hábiles</p>
            <button
              id="button-create-transaction"
              class="button is-button-primary is-rounded"
              @click="$emit('create-transaction')">
              Validar mi pago
            </button>
          </div>
        </b-modal>
        <b-modal v-model="cancellingRelatedTransaction.isModalActive" :width="600">
          <div class="modal-card-body has-text-centered">
            <div class="modal-card-header">
              <div class="is-pulled-right">
                <a class="close-modal" @click="cancellingRelatedTransaction.isModalActive=false">
                  <img src="@/ui/assets/img/plus-button.svg">
                </a>
              </div>
              <h3 class="modal-title">Anular Pago</h3>
            </div>
            <section class="modal-card-body">
              <p>
                Al hacer click en "Anular Pago", se descartará el pago creado
                y las cuotas volverán a estar disponibles para ser pagadas. Si
                realizaste una transacción, será necesario que vuelvas a hacer
                el proceso de pago para que sea validada.
              </p>
              <div class="confirmation-buttons">
                <button
                  id="cancel-transaction-anulation"
                  class="button is-button-secondary is-rounded"
                  @click="cancellingRelatedTransaction.isModalActive=false">
                  Volver
                </button>
                <button
                  id="anulate-transaction"
                  class="button is-button-primary is-rounded"
                  :disabled="cancellingRelatedTransaction.disabledCancelButton"
                  @click="cancelCurrentTransaction">
                  Anular Pago
                </button>
              </div>
            </section>
          </div>
        </b-modal>
        <b-modal v-model="confirmSelection.isModalActive" :width="600">
          <div class="modal-card-body has-text-centered">
            <div class="modal-card-header">
              <div class="is-pulled-right">
                <a class="close-modal" @click="confirmSelection.isModalActive=false">
                  <img src="@/ui/assets/img/plus-button.svg">
                </a>
              </div>
              <h3 class="modal-title">
                <span class="modal-alert-title">Alerta</span><br>
                ¿De verdad quieres dejar impaga una de tus cuotas de este mes?
              </h3>
            </div>
            <section class="modal-card-body">
              <p>
                Podrías caer en mora, generando intereses penales y cobros adicionales (según la Ley del Consumidor - Nº 19.496).
              </p>
              <div class="confirmation-buttons">
                <button
                  id="anulate-transaction"
                  class="button is-button-secondary is-rounded"
                  @click="emitCheckboxEvent(confirmSelection.event)">
                  Dejar una impaga
                </button>
                <button
                  id="cancel-transaction-anulation"
                  class="button is-button-primary is-rounded"
                  @click="confirmSelection.isModalActive=false">
                  Mejor pagar las dos
                </button>
              </div>
            </section>
          </div>
        </b-modal>
        <b-modal v-model="isTrustedIdNumbersCardModalActive" scroll="keep">
          <trusted-id-numbers @is-modal-active="isTrustedIdNumbersCardModalActive=$event" />
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import StepsBar from '@/ui/components/steps/StepsBar.vue';
import TrustedIdNumbers from '@/ui/components/internal/settings/TrustedIdNumbers.vue';
import { cancelTransaction } from '@/application/services/api-clients/transactions';

export default {
  name: 'PayHere',
  components: { StepsBar, TrustedIdNumbers },
  data() {
    return {
      nextStepName: '',
      backStepName: '',
      transactionId: '',
      eventNext: () => {},
      enableNextButton: false,
      enableBackButton: true,
      steps: [
        {
          text: '1. Cuota',
          paths: [
            {
              path: 'seleccionar',
              showFooter: true,
              showNextButton: true,
              showBackButton: false
            }
          ]
        },
        {
          text: '2. Medio de pago',
          paths: [
            {
              path: 'medio-de-pago',
              showFooter: true,
              showNextButton: true,
              showBackButton: true
            }
          ]
        },
        {
          text: '3. Pago',
          paths: [
            {
              path: 'pagar-manual',
              showFooter: true,
              showNextButton: false,
              showBackButton: false
            },
            {
              path: 'pagar-presencial',
              showFooter: true,
              showNextButton: false,
              showBackButton: false,
              nextButtonText: 'Finalizar'
            },
            {
              path: 'pagar-floid',
              showFooter: true,
              showNextButton: false,
              showBackButton: false
            },
            {
              path: 'pagar-servipag',
              showFooter: true,
              showNextButton: false,
              showBackButton: false
            }
          ]
        }
      ],
      confirmingTransaction: { isModalActive: false },
      cancellingRelatedTransaction: {
        isModalActive: false,
        transactionToCancel: '',
        disabledCancelButton: true
      },
      modalProps: {
        title: '',
        content: '',
        html: '',
        footer: '',
        buttonAction: '',
        buttonText: ''
      },
      confirmSelection: {
        isModalActive: false,
        event: undefined
      },
      isTrustedIdNumbersCardModalActive: false
    };
  },
  computed: {
    transactionDebtAmount() {
      return new Intl.NumberFormat('de-DE').format(this.$store.state.paymentsModule.transactionData.debtAmount);
    },
    usedClientBalance() {
      return new Intl.NumberFormat('de-DE').format(this.$store.state.paymentsModule.transactionData.usedClientBalance);
    },
    transaction() {
      const { transactionData } = this.$store.state.paymentsModule;
      return transactionData || {};
    },
    transactionAmount() {
      const { amount } = this.$store.state.paymentsModule.transactionData;
      if (!amount) {
        return '0';
      }
      return new Intl.NumberFormat('de-DE').format(amount);
    },
    currentPath() {
      const pathSplit = this.$route.path.split('/');
      return pathSplit[pathSplit.length - 1];
    },
    currentStep() {
      const { currentPath } = this;
      return this.steps.find(step => {
        return step.paths.find(({ path }) => {
          return path === currentPath;
        });
      });
    },
    showFooter() {
      const { currentStep, currentPath } = this;
      const foundPathObj = currentStep.paths.find(({ path }) => {
        return path === currentPath;
      });
      return foundPathObj.showFooter;
    },
    showBackButton() {
      const { currentStep, currentPath } = this;
      const foundPathObj = currentStep.paths.find(({ path }) => {
        return path === currentPath;
      });
      return foundPathObj.showBackButton;
    },
    showNextButton() {
      const { currentStep, currentPath } = this;
      const foundPathObj = currentStep.paths.find(({ path }) => {
        return path === currentPath;
      });
      return foundPathObj.showNextButton;
    },
    nextButtonText() {
      const { currentStep, currentPath } = this;
      const foundPathObj = currentStep.paths.find(({ path }) => {
        return path === currentPath;
      });
      return foundPathObj.nextButtonText || 'Continuar';
    }
  },
  mounted() {},
  methods: {
    async onlyNeatPagos() {
      if (this.nextStepName === 'pay-neat') {
        await cancelTransaction(this.transactionId);
        window.open('https://neatpagos.com/more', '_blank');
      }
    },
    async continueNext() {
      if (this.eventNext) {
        this.enableNextButton = false;
        await this.eventNext();
        this.enableNextButton = true;
      }
      if (this.nextStepName !== '') {
        await this.onlyNeatPagos();
        this.$router.push({ name: this.nextStepName });
      }
    },
    returnBack() {
      if (this.backStepName !== '') this.$router.push({ name: this.backStepName });
    },
    setNextStepName(value) {
      this.nextStepName = value;
    },
    setBackStepName(value) {
      this.backStepName = value;
    },
    setEnableButton(value) {
      this.enableButton = value;
    },
    setEventNext(event) {
      this.eventNext = event || undefined;
    },
    setTransactionId(event) {
      this.transactionId = event;
    },
    updateFooterButtons(value) {
      const { currentStep, currentPath } = this;
      const currentView = this.steps.find(step => step.text === currentStep.text)
        .paths.find(element => element.path === currentPath);
      const [showBackButton, showNextButton] = value;
      currentView.showBackButton = showBackButton;
      currentView.showNextButton = showNextButton;
    },
    openCancelTransactionModal(transactionId) {
      if (!transactionId) {
        this.cancellingRelatedTransaction.isModalActive = false;
        this.cancellingRelatedTransaction.transactionToCancel = '';
      } else {
        this.cancellingRelatedTransaction.transactionToCancel = transactionId;
        this.cancellingRelatedTransaction.isModalActive = true;
        this.cancellingRelatedTransaction.disabledCancelButton = false;
      }
    },
    openConfirmTransactionModal(activate) {
      this.confirmingTransaction.isModalActive = activate;
    },
    emitCheckboxEvent($event) {
      this.confirmSelection.isModalActive = false;
      this.$emit('change', $event);
    },
    confirmDeselectPayment($event) {
      // Si está seleccionando una cuota, no le pide confirmación
      if ($event.checked) {
        this.emitCheckboxEvent($event);
        return;
      }
      // Si está deseleccionando...
      this.confirmSelection.event = $event;
      this.confirmSelection.isModalActive = true;
    },
    cancelCurrentTransaction() {
      if (!this.cancellingRelatedTransaction.disabledCancelButton) {
        this.cancellingRelatedTransaction.disabledCancelButton = true;
        this.$emit('cancel-transaction', this.cancellingRelatedTransaction.transactionToCancel);
      }
    }
  }
};
</script>
<style scoped>
  .pay-here-content{
    padding-bottom: 70px;
  }
  .steps-module-content{
    width: 95%;
    margin: auto;
  }

  .footer-resume {
    position: fixed;
    background-color: var(--color-snow);
    padding: 20px 60px;
    border-top-left-radius: 35px;
    border-top-right-radius: 35px;
    box-shadow: 0px -4px 8px #00000014;
    left: calc(4% + 230px);
    right: 4%;
    bottom: 0;
    -webkit-transform: translateY(calc(100% + 4px));
    transform: translateY(calc(100% + 4px));
  }
  .footer-resume.active {
    -webkit-transform: translateY(0%);
    transform: translateY(0%);
  }
  .footer-resume .total-content{
    width: 50%;
    float: left;
    font-size: 22px;
    padding: 6px 0px;
    text-align: center;
  }
  .footer-resume .total-content span{
    color: var(--primary);
  }
  .footer-resume .button-content{
    float: left;
    width: 25%;
    min-height: 1px;
  }
  .footer-resume .button-content .button{
    display: block;
    margin: auto;
  }
  .modal-card-body {
    position: relative;
    padding-bottom: 40px;
  }
  .modal-card-body .close-modal {
    position: absolute;
    right: 20px;
    top:20px;
    width: 40px;
  }
  .modal-title{
    font-size: 18px;
    margin-bottom: 20px;
    padding-top: 40px;
  }
  .modal-content{
    margin-bottom: 30px;
    font-size: 14px;
    width: 100%;
    max-width: 400px;
  }
  .modal-footer{
    margin-bottom: 30px;
    font-size: 12px;
  }
  .close-modal {
    position: absolute;
    right: 20px;
    top:20px;
    width: 40px;
  }
  .modal-alert-title {
    color: var(--secondary);
    text-transform: uppercase;
    font-weight: bold;
  }

  @media (max-width: 1100px) {
    .footer-resume .total-content{
    font-size: 20px;
    }
  }
  @media (max-width: 1024px) {
    .footer-resume {
      left: calc(4% + 190px);
    }
  }

  @media (max-width: 768px) {
    .footer-resume {
      left: 4%;
      padding-top: 60px;
    }
    .footer-resume .total-content{
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      top: 15px;
    }
    .footer-resume .button-content {
      width: 50%;
    }
    .footer-resume .button-content.complete {
      width: 100%;
    }
    .footer-resume .button-content.hidden {
      width: 0%;
    }
     .footer-resume .button-content .button{
      width: auto;
    }
  }
  @media (max-width: 400px) {
    .footer-resume .button-content .button{
      padding: 10px 20px;
      font-size: 16px;
    }
  }
</style>
